// Agents: activity log: the routes and the sidebar rows of `wealth.ai.agents.activity-log` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.ai.agents.activity-log',
    routes: [
        {
            frontend: 'comply',
            path: 'agent-activity-log',
            lazy: () => import('@/pages/view/agent-activity-log/page'),
        },
        {
            frontend: 'view',
            path: 'agent-activity-log',
            lazy: () => import('@/pages/view/agent-activity-log/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'agent-activity-log',
            label: 'Agent Activity Log',
            href: '/comply/agent-activity-log',
            icon: 'Activity',
            group: 'automation',
            order: 720,
        },
        {
            frontend: 'view',
            key: 'agent-activity-log',
            label: 'Agent Activity Log',
            href: '/view/agent-activity-log',
            icon: 'Activity',
            group: 'platform',
            order: 520,
        },
    ],
});
